/**
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

export default {
  "en-US": {
    "123/[translation hint:default icon alt text]": "123",
    "alert/[translation hint:default icon alt text]": "Alert",
    "arrow down/[translation hint:default icon alt text]": "Arrow Down",
    "arrow left/[translation hint:default icon alt text]": "Arrow Left",
    "arrow up/[translation hint:default icon alt text]": "Arrow Up",
    "asterisk/[translation hint:default icon alt text]": "Asterisk",
    "checkmark/[translation hint:default icon alt text]": "Checkmark",
    "chevron down/[translation hint:default icon alt text]": "Expand",
    "chevron left/[translation hint:default icon alt text]": "Back",
    "chevron right/[translation hint:default icon alt text]": "Expand",
    "chevron up/[translation hint:default icon alt text]": "Collapse",
    "corner triangle/[translation hint:default icon alt text]": "Expand",
    "cross/[translation hint:default icon alt text]": "Close",
    "dash/[translation hint:default icon alt text]": "Dash",
    "double gripper/[translation hint:default icon alt text]": "Double Gripper",
    "help/[translation hint:default icon alt text]": "Help",
    "info/[translation hint:default icon alt text]": "Info",
    "magnifier/[translation hint:default icon alt text]": "Magnifier",
    "skip left/[translation hint:default icon alt text]": "Skip Left",
    "skip right/[translation hint:default icon alt text]": "Skip Right",
    "star/[translation hint:default icon alt text]": "Star",
    "success/[translation hint:default icon alt text]": "Success",
    "triple gripper/[translation hint:default icon alt text]": "Triple Gripper",
    "3dmaterials/[translation hint:default icon alt text]": "3D Materials",
    "abc/[translation hint:default icon alt text]": "ABC",
    "actions/[translation hint:default icon alt text]": "Actions",
    "ad display/[translation hint:default icon alt text]": "Ad Display",
    "ad print/[translation hint:default icon alt text]": "Ad Print",
    "add/[translation hint:default icon alt text]": "Add",
    "add circle/[translation hint:default icon alt text]": "Add",
    "add to/[translation hint:default icon alt text]": "Add To",
    "add to selection/[translation hint:default icon alt text]": "Add To Selection",
    "adobe advertising cloud/[translation hint:default icon alt text]": "Adobe Advertising Cloud",
    "adobe analytics/[translation hint:default icon alt text]": "Adobe Analytics",
    "adobe analytics cloud/[translation hint:default icon alt text]": "Adobe Analytics Cloud",
    "adobe audience manager/[translation hint:default icon alt text]": "Adobe Audience Manager",
    "adobe campaign/[translation hint:default icon alt text]": "Adobe Campaign",
    "adobe connect/[translation hint:default icon alt text]": "Adobe Connect",
    "adobe document cloud/[translation hint:default icon alt text]": "Adobe Document Cloud",
    "adobe experience cloud/[translation hint:default icon alt text]": "Adobe Experience Cloud",
    "adobe experience manager/[translation hint:default icon alt text]": "Adobe Experience Manager",
    "adobe logo/[translation hint:default icon alt text]": "Adobe Logo",
    "adobe marketing cloud/[translation hint:default icon alt text]": "Adobe Marketing Cloud",
    "adobe media optimizer/[translation hint:default icon alt text]": "Adobe Media Optimizer",
    "adobe primetime/[translation hint:default icon alt text]": "Adobe Primetime",
    "adobe send now/[translation hint:default icon alt text]": "Adobe Send Now",
    "adobe sign/[translation hint:default icon alt text]": "Adobe Sign",
    "adobe social/[translation hint:default icon alt text]": "Adobe Social",
    "adobe target/[translation hint:default icon alt text]": "Adobe Target",
    "after effects/[translation hint:default icon alt text]": "After Effects",
    "alert add/[translation hint:default icon alt text]": "Alert Add",
    "alert check/[translation hint:default icon alt text]": "Alert Check",
    "alert circle/[translation hint:default icon alt text]": "Alert",
    "alias/[translation hint:default icon alt text]": "Alias",
    "align bottom/[translation hint:default icon alt text]": "Align Bottom",
    "align center/[translation hint:default icon alt text]": "Align Center",
    "align left/[translation hint:default icon alt text]": "Align Left",
    "align middle/[translation hint:default icon alt text]": "Align Middle",
    "align right/[translation hint:default icon alt text]": "Align Right",
    "align top/[translation hint:default icon alt text]": "Align Top",
    "amazon web services/[translation hint:default icon alt text]": "Amazon Web Services",
    "anchor/[translation hint:default icon alt text]": "Anchor",
    "anchor select/[translation hint:default icon alt text]": "Select Anchor",
    "android/[translation hint:default icon alt text]": "Android",
    "annotate/[translation hint:default icon alt text]": "Annotate",
    "annotate pen/[translation hint:default icon alt text]": "Annotate Pen",
    "answer/[translation hint:default icon alt text]": "Answer",
    "answer favorite/[translation hint:default icon alt text]": "Favorite Answer",
    "app/[translation hint:default icon alt text]": "App",
    "app refresh/[translation hint:default icon alt text]": "App Refresh",
    "apple/[translation hint:default icon alt text]": "Apple",
    "apple files/[translation hint:default icon alt text]": "Apple Files",
    "approve reject/[translation hint:default icon alt text]": "Approve Reject",
    "apps/[translation hint:default icon alt text]": "Apps",
    "archive/[translation hint:default icon alt text]": "Archive",
    "archive remove/[translation hint:default icon alt text]": "Remove Archive",
    "arrow right/[translation hint:default icon alt text]": "Arrow Right",
    "arrow up right/[translation hint:default icon alt text]": "Arrow Up Right",
    "artboard/[translation hint:default icon alt text]": "Artboard",
    "article/[translation hint:default icon alt text]": "Article",
    "asset/[translation hint:default icon alt text]": "Asset",
    "asset check/[translation hint:default icon alt text]": "Asset Check",
    "assets added/[translation hint:default icon alt text]": "Assets Added",
    "assets downloaded/[translation hint:default icon alt text]": "Assets Downloaded",
    "assets expired/[translation hint:default icon alt text]": "Assets Expired",
    "assets linked published/[translation hint:default icon alt text]": "Assets Linked Published",
    "assets modified/[translation hint:default icon alt text]": "Assets Modified",
    "assets published/[translation hint:default icon alt text]": "Assets Published",
    "at/[translation hint:default icon alt text]": "At",
    "attach/[translation hint:default icon alt text]": "Attach",
    "attachment exclude/[translation hint:default icon alt text]": "Attachment Exclude",
    "attributes/[translation hint:default icon alt text]": "Attributes",
    "audio/[translation hint:default icon alt text]": "Audio",
    "automated segment/[translation hint:default icon alt text]": "Automated Segment",
    "back/[translation hint:default icon alt text]": "Back",
    "back 30seconds/[translation hint:default icon alt text]": "Back 30 Seconds",
    "back android/[translation hint:default icon alt text]": "Back Android",
    "beaker/[translation hint:default icon alt text]": "Beaker",
    "beaker check/[translation hint:default icon alt text]": "Beaker Check",
    "beaker share/[translation hint:default icon alt text]": "Beaker Share",
    "behance/[translation hint:default icon alt text]": "Behance",
    "bell/[translation hint:default icon alt text]": "Bell",
    "bid rule/[translation hint:default icon alt text]": "Bid Rule",
    "bid rule add/[translation hint:default icon alt text]": "Bid Rule Add",
    "bitly/[translation hint:default icon alt text]": "Bitly",
    "blackberry/[translation hint:default icon alt text]": "Blackberry",
    "blog/[translation hint:default icon alt text]": "Blog",
    "blower/[translation hint:default icon alt text]": "Blower",
    "blur/[translation hint:default icon alt text]": "Blur",
    "book/[translation hint:default icon alt text]": "Book",
    "bookmark/[translation hint:default icon alt text]": "Bookmark",
    "boolean/[translation hint:default icon alt text]": "Boolean",
    "border/[translation hint:default icon alt text]": "Border",
    "box/[translation hint:default icon alt text]": "Box",
    "box add/[translation hint:default icon alt text]": "Box Add",
    "box export/[translation hint:default icon alt text]": "Box Export",
    "box import/[translation hint:default icon alt text]": "Box Import",
    "brackets/[translation hint:default icon alt text]": "Brackets",
    "brackets square/[translation hint:default icon alt text]": "Brackets Square",
    "branch 1/[translation hint:default icon alt text]": "Branch 1",
    "branch 2/[translation hint:default icon alt text]": "Branch 2",
    "branch 3/[translation hint:default icon alt text]": "Branch 3",
    "branch circle/[translation hint:default icon alt text]": "Branch",
    "breadcrumb navigation/[translation hint:default icon alt text]": "Breadcrumb Navigation",
    "breakdown/[translation hint:default icon alt text]": "Breakdown",
    "breakdown add/[translation hint:default icon alt text]": "Breakdown Add",
    "briefcase/[translation hint:default icon alt text]": "Briefcase",
    "browse/[translation hint:default icon alt text]": "Browse",
    "brush/[translation hint:default icon alt text]": "Brush",
    "bug/[translation hint:default icon alt text]": "Bug",
    "building/[translation hint:default icon alt text]": "Building",
    "bulk edit users/[translation hint:default icon alt text]": "Bulk Edit Users",
    "button/[translation hint:default icon alt text]": "Button",
    "cclibrary/[translation hint:default icon alt text]": "CC Library",
    "calculator/[translation hint:default icon alt text]": "Calculator",
    "calendar/[translation hint:default icon alt text]": "Calendar",
    "calendar add/[translation hint:default icon alt text]": "Calendar Add",
    "calendar locked/[translation hint:default icon alt text]": "Calendar Locked",
    "calendar unlocked/[translation hint:default icon alt text]": "Calendar Unlocked",
    "call center/[translation hint:default icon alt text]": "Call Center",
    "camera/[translation hint:default icon alt text]": "Camera",
    "camera flip/[translation hint:default icon alt text]": "Camera Flip",
    "camera refresh/[translation hint:default icon alt text]": "Camera Refresh",
    "campaign/[translation hint:default icon alt text]": "Campaign",
    "campaign add/[translation hint:default icon alt text]": "Campaign Add",
    "campaign close/[translation hint:default icon alt text]": "Campaign Close",
    "campaign delete/[translation hint:default icon alt text]": "Campaign Delete",
    "campaign edit/[translation hint:default icon alt text]": "Campaign Edit",
    "cancel/[translation hint:default icon alt text]": "Cancel",
    "capitals/[translation hint:default icon alt text]": "Capitals",
    "captcha/[translation hint:default icon alt text]": "Captcha",
    "card/[translation hint:default icon alt text]": "Card",
    "channel/[translation hint:default icon alt text]": "Channel",
    "chat/[translation hint:default icon alt text]": "Chat",
    "chat add/[translation hint:default icon alt text]": "Chat Add",
    "check pause/[translation hint:default icon alt text]": "Check Pause",
    "checkmark circle/[translation hint:default icon alt text]": "Checkmark",
    "chevron double left/[translation hint:default icon alt text]": "Back",
    "chevron double right/[translation hint:default icon alt text]": "Forward",
    "chevron up down/[translation hint:default icon alt text]": "Sortable",
    "chrome/[translation hint:default icon alt text]": "Chrome",
    "circle/[translation hint:default icon alt text]": "Circle",
    "classic grid view/[translation hint:default icon alt text]": "Classic Grid View",
    "clock/[translation hint:default icon alt text]": "Clock",
    "clock check/[translation hint:default icon alt text]": "Clock Check",
    "clone stamp/[translation hint:default icon alt text]": "Clone Stamp",
    "close/[translation hint:default icon alt text]": "Close",
    "close captions/[translation hint:default icon alt text]": "Close Captions",
    "close circle/[translation hint:default icon alt text]": "Close",
    "cloud/[translation hint:default icon alt text]": "Cloud",
    "cloud disconnected/[translation hint:default icon alt text]": "Cloud Disconnected",
    "cloud error/[translation hint:default icon alt text]": "Cloud Error",
    "code/[translation hint:default icon alt text]": "Code",
    "collection/[translation hint:default icon alt text]": "Collection",
    "collection add/[translation hint:default icon alt text]": "Collection Add",
    "collection add to/[translation hint:default icon alt text]": "Collection Add To",
    "collection check/[translation hint:default icon alt text]": "Collection Check",
    "collection edit/[translation hint:default icon alt text]": "Collection Edit",
    "collection exclude/[translation hint:default icon alt text]": "Collection Exclude",
    "collection link/[translation hint:default icon alt text]": "Collection Link",
    "color fill/[translation hint:default icon alt text]": "Color Fill",
    "color palette/[translation hint:default icon alt text]": "Color Palette",
    "color wheel/[translation hint:default icon alt text]": "Color Wheel",
    "column settings/[translation hint:default icon alt text]": "Column Settings",
    "column two a/[translation hint:default icon alt text]": "Column Two A",
    "column two b/[translation hint:default icon alt text]": "Column Two B",
    "column two c/[translation hint:default icon alt text]": "Column Two C",
    "comment/[translation hint:default icon alt text]": "Comment",
    "compare/[translation hint:default icon alt text]": "Compare",
    "compass/[translation hint:default icon alt text]": "Compass",
    "condition/[translation hint:default icon alt text]": "Condition",
    "confidence four/[translation hint:default icon alt text]": "Confidence Four",
    "confidence one/[translation hint:default icon alt text]": "Confidence One",
    "confidence three/[translation hint:default icon alt text]": "Confidence Three",
    "confidence two/[translation hint:default icon alt text]": "Confidence Two",
    "contrast/[translation hint:default icon alt text]": "Contrast",
    "conversion funnel/[translation hint:default icon alt text]": "Conversion Funnel",
    "copy/[translation hint:default icon alt text]": "Copy",
    "cover image/[translation hint:default icon alt text]": "Cover Image",
    "creative cloud/[translation hint:default icon alt text]": "Creative Cloud",
    "credit card/[translation hint:default icon alt text]": "Credit Card",
    "crop/[translation hint:default icon alt text]": "Crop",
    "crop lightning/[translation hint:default icon alt text]": "Crop Lightning",
    "crop rotate/[translation hint:default icon alt text]": "Crop Rotate",
    "crosshairs/[translation hint:default icon alt text]": "Crosshairs",
    "curate/[translation hint:default icon alt text]": "Curate",
    "cut/[translation hint:default icon alt text]": "Cut",
    "dps/[translation hint:default icon alt text]": "DPS",
    "dashboard/[translation hint:default icon alt text]": "Dashboard",
    "data/[translation hint:default icon alt text]": "Data",
    "data add/[translation hint:default icon alt text]": "Data Add",
    "data adobe/[translation hint:default icon alt text]": "Data Adobe",
    "data book/[translation hint:default icon alt text]": "Data Book",
    "data check/[translation hint:default icon alt text]": "Data Check",
    "data correlated/[translation hint:default icon alt text]": "Data Correlated",
    "data download/[translation hint:default icon alt text]": "Data Download",
    "data edit/[translation hint:default icon alt text]": "Data Edit",
    "data mapping/[translation hint:default icon alt text]": "Data Mapping",
    "data refresh/[translation hint:default icon alt text]": "Data Refresh",
    "data remove/[translation hint:default icon alt text]": "Data Remove",
    "data settings/[translation hint:default icon alt text]": "Data Settings",
    "data unavailable/[translation hint:default icon alt text]": "Data Unavailable",
    "data upload/[translation hint:default icon alt text]": "Data Upload",
    "data user/[translation hint:default icon alt text]": "Data User",
    "date/[translation hint:default icon alt text]": "Date",
    "date input/[translation hint:default icon alt text]": "Date Input",
    "deduplication/[translation hint:default icon alt text]": "Deduplication",
    "delegate/[translation hint:default icon alt text]": "Delegate",
    "delete/[translation hint:default icon alt text]": "Delete",
    "delivery fusion/[translation hint:default icon alt text]": "Delivery Fusion",
    "demographic/[translation hint:default icon alt text]": "Demographic",
    "deselect/[translation hint:default icon alt text]": "Deselect",
    "deselect circular/[translation hint:default icon alt text]": "Deselect",
    "desktop and mobile/[translation hint:default icon alt text]": "Desktop And Mobile",
    "device desktop/[translation hint:default icon alt text]": "Device Desktop",
    "device laptop/[translation hint:default icon alt text]": "Device Laptop",
    "device phone/[translation hint:default icon alt text]": "Device Phone",
    "device phone refresh/[translation hint:default icon alt text]": "Device Phone Refresh",
    "device preview/[translation hint:default icon alt text]": "Device Preview",
    "device rotate landscape/[translation hint:default icon alt text]": "Device Rotate Landscape",
    "device rotate portrait/[translation hint:default icon alt text]": "Device Rotate Portrait",
    "device tv/[translation hint:default icon alt text]": "Device TV",
    "device tablet/[translation hint:default icon alt text]": "Device Tablet",
    "devices/[translation hint:default icon alt text]": "Devices",
    "dimension/[translation hint:default icon alt text]": "Dimension",
    "disqus/[translation hint:default icon alt text]": "Disqus",
    "distribute bottom edge/[translation hint:default icon alt text]": "Distribute Bottom Edge",
    "distribute horizontal center/[translation hint:default icon alt text]": "Distribute Horizontal Center",
    "distribute horizontally/[translation hint:default icon alt text]": "Distribute Horizontally",
    "distribute left edge/[translation hint:default icon alt text]": "Distribute Left Edge",
    "distribute right edge/[translation hint:default icon alt text]": "Distribute Right Edge",
    "distribute space horiz/[translation hint:default icon alt text]": "Distribute Space Horizontally",
    "distribute space vert/[translation hint:default icon alt text]": "Distribute Space Vertically",
    "distribute top edge/[translation hint:default icon alt text]": "Distribute Top Edge",
    "distribute vertical center/[translation hint:default icon alt text]": "Distribute Vertical Center",
    "distribute vertically/[translation hint:default icon alt text]": "Distribute Vertically",
    "divide/[translation hint:default icon alt text]": "Divide",
    "divide path/[translation hint:default icon alt text]": "Divide Path",
    "document/[translation hint:default icon alt text]": "Document",
    "document fragment/[translation hint:default icon alt text]": "Document Fragment",
    "document fragment group/[translation hint:default icon alt text]": "Document Fragment Group",
    "document refresh/[translation hint:default icon alt text]": "Document Refresh",
    "dolly/[translation hint:default icon alt text]": "Dolly",
    "download/[translation hint:default icon alt text]": "Download",
    "download from cloud/[translation hint:default icon alt text]": "Download From Cloud",
    "draft/[translation hint:default icon alt text]": "Draft",
    "drag handle/[translation hint:default icon alt text]": "Drag Handle",
    "draw/[translation hint:default icon alt text]": "Draw",
    "dropdown/[translation hint:default icon alt text]": "Dropdown",
    "duplicate/[translation hint:default icon alt text]": "Duplicate",
    "edit/[translation hint:default icon alt text]": "Edit",
    "edit circle/[translation hint:default icon alt text]": "Edit",
    "edit exclude/[translation hint:default icon alt text]": "Edit Exclude",
    "edit in/[translation hint:default icon alt text]": "Edit In",
    "education/[translation hint:default icon alt text]": "Education",
    "effects/[translation hint:default icon alt text]": "Effects",
    "efficient/[translation hint:default icon alt text]": "Efficient",
    "ellipse/[translation hint:default icon alt text]": "Ellipse",
    "email/[translation hint:default icon alt text]": "Email",
    "email cancel/[translation hint:default icon alt text]": "Email Cancel",
    "email check/[translation hint:default icon alt text]": "Email Check",
    "email exclude/[translation hint:default icon alt text]": "Email Exclude",
    "email gear/[translation hint:default icon alt text]": "Email Gear",
    "email key/[translation hint:default icon alt text]": "Email Key",
    "email lightning/[translation hint:default icon alt text]": "Email Lightning",
    "email notification/[translation hint:default icon alt text]": "Email Notification",
    "email refresh/[translation hint:default icon alt text]": "Email Refresh",
    "email schedule/[translation hint:default icon alt text]": "Email Schedule",
    "engagement/[translation hint:default icon alt text]": "Engagement",
    "erase/[translation hint:default icon alt text]": "Erase",
    "event/[translation hint:default icon alt text]": "Event",
    "event exclude/[translation hint:default icon alt text]": "Event Exclude",
    "event share/[translation hint:default icon alt text]": "Event Share",
    "events/[translation hint:default icon alt text]": "Events",
    "exclude overlap/[translation hint:default icon alt text]": "Exclude Overlap",
    "experience/[translation hint:default icon alt text]": "Experience",
    "experience add/[translation hint:default icon alt text]": "Experience Add",
    "experience add to/[translation hint:default icon alt text]": "Experience Add To",
    "experience export/[translation hint:default icon alt text]": "Experience Export",
    "experience import/[translation hint:default icon alt text]": "Experience Import",
    "export/[translation hint:default icon alt text]": "Export",
    "export original/[translation hint:default icon alt text]": "Export Original",
    "exposure/[translation hint:default icon alt text]": "Exposure",
    "extension/[translation hint:default icon alt text]": "Extension",
    "facebook/[translation hint:default icon alt text]": "Facebook",
    "facebook cover image/[translation hint:default icon alt text]": "Facebook Cover Image",
    "fast/[translation hint:default icon alt text]": "Fast",
    "fast forward/[translation hint:default icon alt text]": "Fast Forward",
    "fast forward circle/[translation hint:default icon alt text]": "Fast Forward",
    "feed/[translation hint:default icon alt text]": "Feed",
    "feed add/[translation hint:default icon alt text]": "Feed Add",
    "feed management/[translation hint:default icon alt text]": "Feed Management",
    "feedback/[translation hint:default icon alt text]": "Feedback",
    "file add/[translation hint:default icon alt text]": "File Add",
    "file csv/[translation hint:default icon alt text]": "File CSV",
    "file campaign/[translation hint:default icon alt text]": "File Campaign",
    "file chart/[translation hint:default icon alt text]": "File Chart",
    "file checked out/[translation hint:default icon alt text]": "File Checked Out",
    "file code/[translation hint:default icon alt text]": "File Code",
    "file data/[translation hint:default icon alt text]": "File Data",
    "file email/[translation hint:default icon alt text]": "File Email",
    "file excel/[translation hint:default icon alt text]": "File Excel",
    "file folder/[translation hint:default icon alt text]": "File Folder",
    "file gear/[translation hint:default icon alt text]": "File Gear",
    "file globe/[translation hint:default icon alt text]": "File Globe",
    "file html/[translation hint:default icon alt text]": "File HTML",
    "file important/[translation hint:default icon alt text]": "File Important",
    "file json/[translation hint:default icon alt text]": "File JSON",
    "file key/[translation hint:default icon alt text]": "File Key",
    "file mobile/[translation hint:default icon alt text]": "File Mobile",
    "file pdf/[translation hint:default icon alt text]": "File PDF",
    "file share/[translation hint:default icon alt text]": "File Share",
    "file single web page/[translation hint:default icon alt text]": "File Single Web Page",
    "file space/[translation hint:default icon alt text]": "File Space",
    "file template/[translation hint:default icon alt text]": "File Template",
    "file txt/[translation hint:default icon alt text]": "File Txt",
    "file user/[translation hint:default icon alt text]": "File User",
    "file word/[translation hint:default icon alt text]": "File Word",
    "file workflow/[translation hint:default icon alt text]": "File Workflow",
    "file xml/[translation hint:default icon alt text]": "File XML",
    "file zip/[translation hint:default icon alt text]": "File Zip",
    "filing cabinet/[translation hint:default icon alt text]": "Filing Cabinet",
    "fill sign/[translation hint:default icon alt text]": "Fill Sign",
    "filmroll/[translation hint:default icon alt text]": "Filmroll",
    "filmroll auto add/[translation hint:default icon alt text]": "Filmroll Auto Add",
    "filter/[translation hint:default icon alt text]": "Filter",
    "filter add/[translation hint:default icon alt text]": "Filter Add",
    "filter check/[translation hint:default icon alt text]": "Filter Check",
    "filter delete/[translation hint:default icon alt text]": "Filter Delete",
    "filter edit/[translation hint:default icon alt text]": "Filter Edit",
    "filter heart/[translation hint:default icon alt text]": "Filter Heart",
    "filter remove/[translation hint:default icon alt text]": "Filter Remove",
    "filter star/[translation hint:default icon alt text]": "Filter Star",
    "find and replace/[translation hint:default icon alt text]": "Find And Replace",
    "firefox/[translation hint:default icon alt text]": "Firefox",
    "flag/[translation hint:default icon alt text]": "Flag",
    "flag exclude/[translation hint:default icon alt text]": "Flag Exclude",
    "flash/[translation hint:default icon alt text]": "Flash",
    "flash auto/[translation hint:default icon alt text]": "Flash Auto",
    "flash off/[translation hint:default icon alt text]": "Flash Off",
    "flash on/[translation hint:default icon alt text]": "Flash On",
    "flashlight off/[translation hint:default icon alt text]": "Flashlight Off",
    "flashlight on/[translation hint:default icon alt text]": "Flashlight On",
    "flickr/[translation hint:default icon alt text]": "Flickr",
    "flip horizontal/[translation hint:default icon alt text]": "Flip Horizontal",
    "flip vertical/[translation hint:default icon alt text]": "Flip Vertical",
    "folder/[translation hint:default icon alt text]": "Folder",
    "folder 2/[translation hint:default icon alt text]": "Folder",
    "folder add/[translation hint:default icon alt text]": "Folder Add",
    "folder add to/[translation hint:default icon alt text]": "Folder Add To",
    "folder adobe/[translation hint:default icon alt text]": "Folder Adobe",
    "folder archive/[translation hint:default icon alt text]": "Folder Archive",
    "folder delete/[translation hint:default icon alt text]": "Folder Delete",
    "folder gear/[translation hint:default icon alt text]": "Folder Gear",
    "folder locked/[translation hint:default icon alt text]": "Folder Locked",
    "folder locked adobe/[translation hint:default icon alt text]": "Folder Locked Adobe",
    "folder open/[translation hint:default icon alt text]": "Folder Open",
    "folder remove/[translation hint:default icon alt text]": "Folder Remove",
    "folder search/[translation hint:default icon alt text]": "Folder Search",
    "folder user/[translation hint:default icon alt text]": "Folder User",
    "follow/[translation hint:default icon alt text]": "Follow",
    "follow off/[translation hint:default icon alt text]": "Follow Off",
    "for placement only/[translation hint:default icon alt text]": "For Placement Only",
    "forecast/[translation hint:default icon alt text]": "Forecast",
    "form/[translation hint:default icon alt text]": "Form",
    "forward/[translation hint:default icon alt text]": "Forward",
    "full screen/[translation hint:default icon alt text]": "Full Screen",
    "full screen exit/[translation hint:default icon alt text]": "Full Screen Exit",
    "function/[translation hint:default icon alt text]": "Function",
    "game/[translation hint:default icon alt text]": "Game",
    "gauge 1/[translation hint:default icon alt text]": "Gauge 1",
    "gauge 2/[translation hint:default icon alt text]": "Gauge 2",
    "gauge 3/[translation hint:default icon alt text]": "Gauge 3",
    "gauge 4/[translation hint:default icon alt text]": "Gauge 4",
    "gauge 5/[translation hint:default icon alt text]": "Gauge 5",
    "gears/[translation hint:default icon alt text]": "Gears",
    "gears add/[translation hint:default icon alt text]": "Gears Add",
    "gears delete/[translation hint:default icon alt text]": "Gears Delete",
    "gears edit/[translation hint:default icon alt text]": "Gears Edit",
    "gender female/[translation hint:default icon alt text]": "Gender Female",
    "gender male/[translation hint:default icon alt text]": "Gender Male",
    "gift/[translation hint:default icon alt text]": "Gift",
    "git hub/[translation hint:default icon alt text]": "Git Hub",
    "globe/[translation hint:default icon alt text]": "Globe",
    "globe check/[translation hint:default icon alt text]": "Globe Check",
    "globe clock/[translation hint:default icon alt text]": "Globe Clock",
    "globe enter/[translation hint:default icon alt text]": "Globe Enter",
    "globe exit/[translation hint:default icon alt text]": "Globe Exit",
    "globe grid/[translation hint:default icon alt text]": "Globe Grid",
    "globe remove/[translation hint:default icon alt text]": "Globe Remove",
    "globe search/[translation hint:default icon alt text]": "Globe Search",
    "globe strike/[translation hint:default icon alt text]": "Globe Strike",
    "globe strike clock/[translation hint:default icon alt text]": "Globe Strike Clock",
    "google/[translation hint:default icon alt text]": "Google",
    "google analytics/[translation hint:default icon alt text]": "Google Analytics",
    "google play store/[translation hint:default icon alt text]": "Google Play Store",
    "google plus/[translation hint:default icon alt text]": "Google Plus",
    "google plus 1/[translation hint:default icon alt text]": "Google Plus",
    "gradient/[translation hint:default icon alt text]": "Gradient",
    "graph area/[translation hint:default icon alt text]": "Graph Area",
    "graph area stacked/[translation hint:default icon alt text]": "Graph Area Stacked",
    "graph bar horizontal/[translation hint:default icon alt text]": "Graph Bar Horizontal",
    "graph bar horizontal add/[translation hint:default icon alt text]": "Graph Bar Horizontal Add",
    "graph bar horizontal stacked/[translation hint:default icon alt text]": "Graph Bar Horizontal Stacked",
    "graph bar vertical/[translation hint:default icon alt text]": "Graph Bar Vertical",
    "graph bar vertical add/[translation hint:default icon alt text]": "Graph Bar Vertical Add",
    "graph bar vertical stacked/[translation hint:default icon alt text]": "Graph Bar Vertical Stacked",
    "graph bubble/[translation hint:default icon alt text]": "Graph Bubble",
    "graph bullet/[translation hint:default icon alt text]": "Graph Bullet",
    "graph confidence bands/[translation hint:default icon alt text]": "Graph Confidence Bands",
    "graph donut/[translation hint:default icon alt text]": "Graph Donut",
    "graph donut add/[translation hint:default icon alt text]": "Graph Donut Add",
    "graph gantt/[translation hint:default icon alt text]": "Graph Gantt",
    "graph histogram/[translation hint:default icon alt text]": "Graph Histogram",
    "graph pathing/[translation hint:default icon alt text]": "Graph Pathing",
    "graph pie/[translation hint:default icon alt text]": "Graph Pie",
    "graph profit curve/[translation hint:default icon alt text]": "Graph Profit Curve",
    "graph scatter/[translation hint:default icon alt text]": "Graph Scatter",
    "graph stream/[translation hint:default icon alt text]": "Graph Stream",
    "graph stream ranked/[translation hint:default icon alt text]": "Graph Stream Ranked",
    "graph stream ranked add/[translation hint:default icon alt text]": "Graph Stream Ranked Add",
    "graph sunburst/[translation hint:default icon alt text]": "Graph Sunburst",
    "graph tree/[translation hint:default icon alt text]": "Graph Tree",
    "graph trend/[translation hint:default icon alt text]": "Graph Trend",
    "graph trend add/[translation hint:default icon alt text]": "Graph Trend Add",
    "graph trend alert/[translation hint:default icon alt text]": "Graph Trend Alert",
    "graphic/[translation hint:default icon alt text]": "Graphic",
    "group/[translation hint:default icon alt text]": "Group",
    "html5/[translation hint:default icon alt text]": "HTML5",
    "hammer/[translation hint:default icon alt text]": "Hammer",
    "hand/[translation hint:default icon alt text]": "Hand",
    "hand 0/[translation hint:default icon alt text]": "Hand 0",
    "hand 1/[translation hint:default icon alt text]": "Hand 1",
    "hand 2/[translation hint:default icon alt text]": "Hand 2",
    "hand 3/[translation hint:default icon alt text]": "Hand 3",
    "hand 4/[translation hint:default icon alt text]": "Hand 4",
    "heal/[translation hint:default icon alt text]": "Heal",
    "heart/[translation hint:default icon alt text]": "Heart",
    "histogram/[translation hint:default icon alt text]": "Histogram",
    "history/[translation hint:default icon alt text]": "History",
    "home/[translation hint:default icon alt text]": "Home",
    "homepage/[translation hint:default icon alt text]": "Homepage",
    "illustrator/[translation hint:default icon alt text]": "Illustrator",
    "image/[translation hint:default icon alt text]": "Image",
    "image add/[translation hint:default icon alt text]": "Image Add",
    "image album/[translation hint:default icon alt text]": "Image Album",
    "image auto mode/[translation hint:default icon alt text]": "Image Auto Mode",
    "image carousel/[translation hint:default icon alt text]": "Image Carousel",
    "image check/[translation hint:default icon alt text]": "Image Check",
    "image checked out/[translation hint:default icon alt text]": "Image Checked Out",
    "image map circle/[translation hint:default icon alt text]": "Image Map Circle",
    "image map polygon/[translation hint:default icon alt text]": "Image Map Polygon",
    "image map rectangle/[translation hint:default icon alt text]": "Image Map Rectangle",
    "image next/[translation hint:default icon alt text]": "Image Next",
    "image profile/[translation hint:default icon alt text]": "Image Profile",
    "image search/[translation hint:default icon alt text]": "Image Search",
    "image text/[translation hint:default icon alt text]": "Image Text",
    "images/[translation hint:default icon alt text]": "Images",
    "import/[translation hint:default icon alt text]": "Import",
    "in design/[translation hint:default icon alt text]": "In Design",
    "inbox/[translation hint:default icon alt text]": "Inbox",
    "individual/[translation hint:default icon alt text]": "Individual",
    "instagram/[translation hint:default icon alt text]": "Instagram",
    "internet explorer/[translation hint:default icon alt text]": "Internet Explorer",
    "intersect overlap/[translation hint:default icon alt text]": "Intersect Overlap",
    "invert adj/[translation hint:default icon alt text]": "Invert Adj",
    "journey/[translation hint:default icon alt text]": "Journey",
    "journey action/[translation hint:default icon alt text]": "Journey Action",
    "journey data/[translation hint:default icon alt text]": "Journey Data",
    "journey event/[translation hint:default icon alt text]": "Journey Event",
    "journey event 2/[translation hint:default icon alt text]": "Journey Event",
    "journey reports/[translation hint:default icon alt text]": "Journey Reports",
    "journey voyager/[translation hint:default icon alt text]": "Journey Voyager",
    "jump to top/[translation hint:default icon alt text]": "Jump To Top",
    "key/[translation hint:default icon alt text]": "Key",
    "key clock/[translation hint:default icon alt text]": "Key Clock",
    "key exclude/[translation hint:default icon alt text]": "Key Exclude",
    "keyboard/[translation hint:default icon alt text]": "Keyboard",
    "label/[translation hint:default icon alt text]": "Label",
    "label exclude/[translation hint:default icon alt text]": "Label Exclude",
    "labels/[translation hint:default icon alt text]": "Labels",
    "landscape/[translation hint:default icon alt text]": "Landscape",
    "launch/[translation hint:default icon alt text]": "Launch",
    "layers/[translation hint:default icon alt text]": "Layers",
    "layers backward/[translation hint:default icon alt text]": "Layers Backward",
    "layers bring to front/[translation hint:default icon alt text]": "Layers Bring To Front",
    "layers forward/[translation hint:default icon alt text]": "Layers Forward",
    "layers send to back/[translation hint:default icon alt text]": "Layers Send To Back",
    "lightroom/[translation hint:default icon alt text]": "Lightroom",
    "line/[translation hint:default icon alt text]": "Line",
    "line height/[translation hint:default icon alt text]": "Line Height",
    "linear gradient/[translation hint:default icon alt text]": "Linear Gradient",
    "link/[translation hint:default icon alt text]": "Link",
    "link check/[translation hint:default icon alt text]": "Link Check",
    "link facebook/[translation hint:default icon alt text]": "Link Facebook",
    "link globe/[translation hint:default icon alt text]": "Link Globe",
    "link nav/[translation hint:default icon alt text]": "Link Nav",
    "link off/[translation hint:default icon alt text]": "Link Off",
    "link out/[translation hint:default icon alt text]": "Link Out",
    "link page/[translation hint:default icon alt text]": "Link Page",
    "link user/[translation hint:default icon alt text]": "Link User",
    "linked in/[translation hint:default icon alt text]": "LinkedIn",
    "linux/[translation hint:default icon alt text]": "Linux",
    "location/[translation hint:default icon alt text]": "Location",
    "location based date/[translation hint:default icon alt text]": "Location Based Date",
    "location based event/[translation hint:default icon alt text]": "Location Based Event",
    "location contribution/[translation hint:default icon alt text]": "Location Contribution",
    "lock closed/[translation hint:default icon alt text]": "Lock Closed",
    "lock open/[translation hint:default icon alt text]": "Lock Open",
    "log out/[translation hint:default icon alt text]": "Log Out",
    "login/[translation hint:default icon alt text]": "Login",
    "looks/[translation hint:default icon alt text]": "Looks",
    "loupe view/[translation hint:default icon alt text]": "Loupe View",
    "mbox/[translation hint:default icon alt text]": "MBox",
    "magento commerce/[translation hint:default icon alt text]": "Magento Commerce",
    "magic wand/[translation hint:default icon alt text]": "Magic Wand",
    "magnify/[translation hint:default icon alt text]": "Magnify",
    "mailbox/[translation hint:default icon alt text]": "Mailbox",
    "map view/[translation hint:default icon alt text]": "Map View",
    "margin bottom/[translation hint:default icon alt text]": "Margin Bottom",
    "margin left/[translation hint:default icon alt text]": "Margin Left",
    "margin right/[translation hint:default icon alt text]": "Margin Right",
    "margin top/[translation hint:default icon alt text]": "Margin Top",
    "marketing activities/[translation hint:default icon alt text]": "Marketing Activities",
    "maximize/[translation hint:default icon alt text]": "Maximize",
    "measure/[translation hint:default icon alt text]": "Measure",
    "menu/[translation hint:default icon alt text]": "Menu",
    "merge/[translation hint:default icon alt text]": "Merge",
    "merge layers/[translation hint:default icon alt text]": "Merge Layers",
    "messenger/[translation hint:default icon alt text]": "Messenger",
    "minimize/[translation hint:default icon alt text]": "Minimize",
    "mobile services/[translation hint:default icon alt text]": "Mobile Services",
    "modern grid view/[translation hint:default icon alt text]": "Modern Grid View",
    "money/[translation hint:default icon alt text]": "Money",
    "moon/[translation hint:default icon alt text]": "Moon",
    "more/[translation hint:default icon alt text]": "More",
    "more circle/[translation hint:default icon alt text]": "More",
    "more small list/[translation hint:default icon alt text]": "More Small List",
    "more small list vert/[translation hint:default icon alt text]": "More Small List Vert",
    "more vertical/[translation hint:default icon alt text]": "More Vertical",
    "move/[translation hint:default icon alt text]": "Move",
    "move left right/[translation hint:default icon alt text]": "Move Left or Right",
    "move to/[translation hint:default icon alt text]": "Move To",
    "move up down/[translation hint:default icon alt text]": "Move Up or Down",
    "movie camera/[translation hint:default icon alt text]": "Movie Camera",
    "multiple/[translation hint:default icon alt text]": "Multiple",
    "multiple add/[translation hint:default icon alt text]": "Multiple Add",
    "multiple check/[translation hint:default icon alt text]": "Multiple Check",
    "multiple exclude/[translation hint:default icon alt text]": "Multiple Exclude",
    "muse/[translation hint:default icon alt text]": "Muse",
    "naming order/[translation hint:default icon alt text]": "Naming Order",
    "new item/[translation hint:default icon alt text]": "New Item",
    "news/[translation hint:default icon alt text]": "News",
    "news add/[translation hint:default icon alt text]": "News Add",
    "newsgator/[translation hint:default icon alt text]": "Newsgator",
    "nielsen/[translation hint:default icon alt text]": "Nielsen",
    "no edit/[translation hint:default icon alt text]": "No Edit",
    "note/[translation hint:default icon alt text]": "Note",
    "note add/[translation hint:default icon alt text]": "Note Add",
    "os/[translation hint:default icon alt text]": "OS",
    "offer/[translation hint:default icon alt text]": "Offer",
    "offer delete/[translation hint:default icon alt text]": "Delete Offer",
    "on air/[translation hint:default icon alt text]": "On Air",
    "one drive/[translation hint:default icon alt text]": "One Drive",
    "open in/[translation hint:default icon alt text]": "Open In",
    "open recent/[translation hint:default icon alt text]": "Open Recent",
    "opera/[translation hint:default icon alt text]": "Opera",
    "orbit/[translation hint:default icon alt text]": "Orbit",
    "organisations/[translation hint:default icon alt text]": "Organisations",
    "organize/[translation hint:default icon alt text]": "Organize",
    "outline path/[translation hint:default icon alt text]": "Outline Path",
    "pdfchecked out/[translation hint:default icon alt text]": "PDF Checked Out",
    "padding bottom/[translation hint:default icon alt text]": "Padding Bottom",
    "padding left/[translation hint:default icon alt text]": "Padding Left",
    "padding right/[translation hint:default icon alt text]": "Padding Right",
    "padding top/[translation hint:default icon alt text]": "Padding Top",
    "page break/[translation hint:default icon alt text]": "Page Break",
    "page exclude/[translation hint:default icon alt text]": "Page Exclude",
    "page gear/[translation hint:default icon alt text]": "Page Gear",
    "page rule/[translation hint:default icon alt text]": "Page Rule",
    "page share/[translation hint:default icon alt text]": "Page Share",
    "page tag/[translation hint:default icon alt text]": "Page Tag",
    "pages exclude/[translation hint:default icon alt text]": "Pages Exclude",
    "pan/[translation hint:default icon alt text]": "Pan",
    "panel/[translation hint:default icon alt text]": "Panel",
    "paste/[translation hint:default icon alt text]": "Paste",
    "paste html/[translation hint:default icon alt text]": "Paste HTML",
    "paste list/[translation hint:default icon alt text]": "Paste List",
    "paste text/[translation hint:default icon alt text]": "Paste Text",
    "pattern/[translation hint:default icon alt text]": "Pattern",
    "pause/[translation hint:default icon alt text]": "Pause",
    "pause circle/[translation hint:default icon alt text]": "Pause",
    "pawn/[translation hint:default icon alt text]": "Pawn",
    "pending/[translation hint:default icon alt text]": "Pending",
    "people group/[translation hint:default icon alt text]": "People Group",
    "personalization field/[translation hint:default icon alt text]": "Personalization Field",
    "perspective/[translation hint:default icon alt text]": "Perspective",
    "phone gap/[translation hint:default icon alt text]": "PhoneGap",
    "phone gap builder/[translation hint:default icon alt text]": "PhoneGap Builder",
    "photoshop/[translation hint:default icon alt text]": "Photoshop",
    "pin off/[translation hint:default icon alt text]": "Pin Off",
    "pin on/[translation hint:default icon alt text]": "Pin On",
    "pinterest/[translation hint:default icon alt text]": "Pinterest",
    "pivot/[translation hint:default icon alt text]": "Pivot",
    "platform data mapping/[translation hint:default icon alt text]": "Platform Data Mapping",
    "play/[translation hint:default icon alt text]": "Play",
    "play circle/[translation hint:default icon alt text]": "Play",
    "plug/[translation hint:default icon alt text]": "Plug",
    "polygon/[translation hint:default icon alt text]": "Polygon",
    "polygon select/[translation hint:default icon alt text]": "Polygon Select",
    "pop in/[translation hint:default icon alt text]": "Pop In",
    "portrait/[translation hint:default icon alt text]": "Portrait",
    "premiere pro/[translation hint:default icon alt text]": "Premiere Pro",
    "preset/[translation hint:default icon alt text]": "Preset",
    "preview/[translation hint:default icon alt text]": "Preview",
    "print/[translation hint:default icon alt text]": "Print",
    "print preview/[translation hint:default icon alt text]": "Print Preview",
    "project/[translation hint:default icon alt text]": "Project",
    "project add/[translation hint:default icon alt text]": "Project Add",
    "project edit/[translation hint:default icon alt text]": "Project Edit",
    "project name edit/[translation hint:default icon alt text]": "Project Name Edit",
    "promote/[translation hint:default icon alt text]": "Promote",
    "properties/[translation hint:default icon alt text]": "Properties",
    "properties copy/[translation hint:default icon alt text]": "Properties Copy",
    "public/[translation hint:default icon alt text]": "Public",
    "publish check/[translation hint:default icon alt text]": "Publish Check",
    "publish pending/[translation hint:default icon alt text]": "Publish Pending",
    "publish reject/[translation hint:default icon alt text]": "Publish Reject",
    "publish remove/[translation hint:default icon alt text]": "Publish Remove",
    "publish schedule/[translation hint:default icon alt text]": "Publish Schedule",
    "push notification/[translation hint:default icon alt text]": "Push Notification",
    "question/[translation hint:default icon alt text]": "Question",
    "quick select/[translation hint:default icon alt text]": "Quick Select",
    "rss/[translation hint:default icon alt text]": "RSS",
    "radial gradient/[translation hint:default icon alt text]": "Radial Gradient",
    "rail/[translation hint:default icon alt text]": "Rail",
    "rail bottom/[translation hint:default icon alt text]": "Rail Bottom",
    "rail left/[translation hint:default icon alt text]": "Rail Left",
    "rail right/[translation hint:default icon alt text]": "Rail Right",
    "rail right close/[translation hint:default icon alt text]": "Close Rail Right",
    "rail right open/[translation hint:default icon alt text]": "Open Rail Right",
    "rail top/[translation hint:default icon alt text]": "Rail Top",
    "range mask/[translation hint:default icon alt text]": "Range Mask",
    "rect select/[translation hint:default icon alt text]": "Rect Select",
    "rectangle/[translation hint:default icon alt text]": "Rectangle",
    "redo/[translation hint:default icon alt text]": "Redo",
    "refresh/[translation hint:default icon alt text]": "Refresh",
    "region select/[translation hint:default icon alt text]": "Region Select",
    "relevance/[translation hint:default icon alt text]": "Relevance",
    "remove/[translation hint:default icon alt text]": "Remove",
    "remove circle/[translation hint:default icon alt text]": "Remove",
    "rename/[translation hint:default icon alt text]": "Rename",
    "reorder/[translation hint:default icon alt text]": "Reorder",
    "replay/[translation hint:default icon alt text]": "Replay",
    "replies/[translation hint:default icon alt text]": "Replies",
    "reply/[translation hint:default icon alt text]": "Reply",
    "reply all/[translation hint:default icon alt text]": "Reply All",
    "report/[translation hint:default icon alt text]": "Report",
    "report add/[translation hint:default icon alt text]": "Report Add",
    "resize/[translation hint:default icon alt text]": "Resize",
    "retweet/[translation hint:default icon alt text]": "Retweet",
    "reuse/[translation hint:default icon alt text]": "Reuse",
    "revenue/[translation hint:default icon alt text]": "Revenue",
    "revert/[translation hint:default icon alt text]": "Revert",
    "rewind/[translation hint:default icon alt text]": "Rewind",
    "rewind circle/[translation hint:default icon alt text]": "Rewind",
    "ribbon/[translation hint:default icon alt text]": "Ribbon",
    "rotate ccw/[translation hint:default icon alt text]": "Rotate CCW",
    "rotate ccwbold/[translation hint:default icon alt text]": "Rotate CCW",
    "rotate cw/[translation hint:default icon alt text]": "Rotate CW",
    "rotate cwbold/[translation hint:default icon alt text]": "Rotate CW",
    "rotate left/[translation hint:default icon alt text]": "Rotate Left",
    "rotate right/[translation hint:default icon alt text]": "Rotate Right",
    "sms/[translation hint:default icon alt text]": "SMS",
    "smskey/[translation hint:default icon alt text]": "SMS Key",
    "smslightning/[translation hint:default icon alt text]": "SMS Lightning",
    "smsrefresh/[translation hint:default icon alt text]": "SMS Refresh",
    "sqlquery/[translation hint:default icon alt text]": "SQL Query",
    "safari/[translation hint:default icon alt text]": "Safari",
    "sampler/[translation hint:default icon alt text]": "Sampler",
    "save as floppy/[translation hint:default icon alt text]": "Save As Floppy",
    "save floppy/[translation hint:default icon alt text]": "Save Floppy",
    "save to/[translation hint:default icon alt text]": "Save To",
    "scribble/[translation hint:default icon alt text]": "Scribble",
    "search/[translation hint:default icon alt text]": "Search",
    "seat/[translation hint:default icon alt text]": "Seat",
    "seat add/[translation hint:default icon alt text]": "Seat Add",
    "segments/[translation hint:default icon alt text]": "Segments",
    "select/[translation hint:default icon alt text]": "Select",
    "select add/[translation hint:default icon alt text]": "Select Add",
    "select box/[translation hint:default icon alt text]": "Select Box",
    "select box all/[translation hint:default icon alt text]": "Select Box All",
    "select circular/[translation hint:default icon alt text]": "Select Circular",
    "select container/[translation hint:default icon alt text]": "Select Container",
    "select gear/[translation hint:default icon alt text]": "Select Gear",
    "select intersect/[translation hint:default icon alt text]": "Select Intersect",
    "select substract/[translation hint:default icon alt text]": "Select Substract",
    "selection/[translation hint:default icon alt text]": "Selection",
    "selection checked/[translation hint:default icon alt text]": "Selection Checked",
    "selection move/[translation hint:default icon alt text]": "Selection Move",
    "send/[translation hint:default icon alt text]": "Send",
    "send for signature/[translation hint:default icon alt text]": "Send For Signature",
    "sentiment negative/[translation hint:default icon alt text]": "Sentiment Negative",
    "sentiment neutral/[translation hint:default icon alt text]": "Sentiment Neutral",
    "sentiment positive/[translation hint:default icon alt text]": "Sentiment Positive",
    "separator/[translation hint:default icon alt text]": "Separator",
    "servers/[translation hint:default icon alt text]": "Servers",
    "settings/[translation hint:default icon alt text]": "Settings",
    "shapes/[translation hint:default icon alt text]": "Shapes",
    "share/[translation hint:default icon alt text]": "Share",
    "share android/[translation hint:default icon alt text]": "Share",
    "share check/[translation hint:default icon alt text]": "Share Check",
    "share windows/[translation hint:default icon alt text]": "Share",
    "sharpen/[translation hint:default icon alt text]": "Sharpen",
    "shield/[translation hint:default icon alt text]": "Shield",
    "shopping cart/[translation hint:default icon alt text]": "Shopping Cart",
    "show all layers/[translation hint:default icon alt text]": "Show All Layers",
    "show menu/[translation hint:default icon alt text]": "Show Menu",
    "show one layer/[translation hint:default icon alt text]": "Show One Layer",
    "shuffle/[translation hint:default icon alt text]": "Shuffle",
    "sina weibo/[translation hint:default icon alt text]": "Sina Weibo",
    "slice/[translation hint:default icon alt text]": "Slice",
    "slow/[translation hint:default icon alt text]": "Slow",
    "small caps/[translation hint:default icon alt text]": "Small Caps",
    "snapshot/[translation hint:default icon alt text]": "Snapshot",
    "social network/[translation hint:default icon alt text]": "Social Network",
    "sort order down/[translation hint:default icon alt text]": "Sort Order Down",
    "sort order up/[translation hint:default icon alt text]": "Sort Order Up",
    "spam/[translation hint:default icon alt text]": "Spam",
    "spellcheck/[translation hint:default icon alt text]": "Spellcheck",
    "spin/[translation hint:default icon alt text]": "Spin",
    "split view/[translation hint:default icon alt text]": "Split View",
    "spot heal/[translation hint:default icon alt text]": "Spot Heal",
    "stage/[translation hint:default icon alt text]": "Stage",
    "stamp/[translation hint:default icon alt text]": "Stamp",
    "starburst/[translation hint:default icon alt text]": "Starburst",
    "step backward/[translation hint:default icon alt text]": "Step Backward",
    "step backward circle/[translation hint:default icon alt text]": "Step Backward",
    "step forward/[translation hint:default icon alt text]": "Step Forward",
    "step forward circle/[translation hint:default icon alt text]": "Step Forward",
    "stock/[translation hint:default icon alt text]": "Stock",
    "stop/[translation hint:default icon alt text]": "Stop",
    "stop circle/[translation hint:default icon alt text]": "Stop",
    "stopwatch/[translation hint:default icon alt text]": "Stopwatch",
    "straighten/[translation hint:default icon alt text]": "Straighten",
    "stroke width/[translation hint:default icon alt text]": "Stroke Width",
    "subscribe/[translation hint:default icon alt text]": "Subscribe",
    "substract back path/[translation hint:default icon alt text]": "Substract Back Path",
    "substract from selection/[translation hint:default icon alt text]": "Substract From Selection",
    "subtract front path/[translation hint:default icon alt text]": "Subtract Front Path",
    "success metric/[translation hint:default icon alt text]": "Success Metric",
    "summarize/[translation hint:default icon alt text]": "Summarize",
    "survey/[translation hint:default icon alt text]": "Survey",
    "switch/[translation hint:default icon alt text]": "Switch",
    "sync/[translation hint:default icon alt text]": "Sync",
    "sync remove/[translation hint:default icon alt text]": "Sync Remove",
    "table/[translation hint:default icon alt text]": "Table",
    "table add/[translation hint:default icon alt text]": "Table Add",
    "table and chart/[translation hint:default icon alt text]": "Table And Chart",
    "table column add left/[translation hint:default icon alt text]": "Table Column Add Left",
    "table column add right/[translation hint:default icon alt text]": "Table Column Add Right",
    "table column merge/[translation hint:default icon alt text]": "Table Column Merge",
    "table column remove center/[translation hint:default icon alt text]": "Table Column Remove Center",
    "table column split/[translation hint:default icon alt text]": "Table Column Split",
    "table edit/[translation hint:default icon alt text]": "Table Edit",
    "table histogram/[translation hint:default icon alt text]": "Table Histogram",
    "table merge cells/[translation hint:default icon alt text]": "Table Merge Cells",
    "table row add bottom/[translation hint:default icon alt text]": "Table Row Add Bottom",
    "table row add top/[translation hint:default icon alt text]": "Table Row Add Top",
    "table row merge/[translation hint:default icon alt text]": "Table Row Merge",
    "table row remove center/[translation hint:default icon alt text]": "Table Row Remove Center",
    "table row split/[translation hint:default icon alt text]": "Table Row Split",
    "table select column/[translation hint:default icon alt text]": "Table Select Column",
    "table select row/[translation hint:default icon alt text]": "Table Select Row",
    "tableau/[translation hint:default icon alt text]": "Tableau",
    "tag bold/[translation hint:default icon alt text]": "Tag Bold",
    "tag italic/[translation hint:default icon alt text]": "Tag Italic",
    "tag underline/[translation hint:default icon alt text]": "Tag Underline",
    "target/[translation hint:default icon alt text]": "Target",
    "targeted/[translation hint:default icon alt text]": "Targeted",
    "task list/[translation hint:default icon alt text]": "Task List",
    "teapot/[translation hint:default icon alt text]": "Teapot",
    "temperature/[translation hint:default icon alt text]": "Temperature",
    "test ab/[translation hint:default icon alt text]": "Test AB",
    "test abedit/[translation hint:default icon alt text]": "Test AB Edit",
    "test abgear/[translation hint:default icon alt text]": "Test AB Gear",
    "test abremove/[translation hint:default icon alt text]": "Test AB Remove",
    "test profile/[translation hint:default icon alt text]": "Test Profile",
    "text/[translation hint:default icon alt text]": "Text",
    "text add/[translation hint:default icon alt text]": "Text Add",
    "text align center/[translation hint:default icon alt text]": "Text Align Center",
    "text align justify/[translation hint:default icon alt text]": "Text Align Justify",
    "text align left/[translation hint:default icon alt text]": "Text Align Left",
    "text align right/[translation hint:default icon alt text]": "Text Align Right",
    "text baseline shift/[translation hint:default icon alt text]": "Text Baseline Shift",
    "text bold/[translation hint:default icon alt text]": "Text Bold",
    "text bulleted/[translation hint:default icon alt text]": "Text Bulleted",
    "text bulleted attach/[translation hint:default icon alt text]": "Text Bulleted Attach",
    "text bulleted hierarchy/[translation hint:default icon alt text]": "Text Bulleted Hierarchy",
    "text bulleted hierarchy exclude/[translation hint:default icon alt text]": "Text Bulleted Hierarchy Exclude",
    "text decrease/[translation hint:default icon alt text]": "Text Decrease",
    "text edit/[translation hint:default icon alt text]": "Text Edit",
    "text exclude/[translation hint:default icon alt text]": "Text Exclude",
    "text increase/[translation hint:default icon alt text]": "Text Increase",
    "text indent decrease/[translation hint:default icon alt text]": "Text Indent Decrease",
    "text indent increase/[translation hint:default icon alt text]": "Text Indent Increase",
    "text italic/[translation hint:default icon alt text]": "Text Italic",
    "text kerning/[translation hint:default icon alt text]": "Text Kerning",
    "text lettered lower case/[translation hint:default icon alt text]": "Text Lettered Lower Case",
    "text lettered upper case/[translation hint:default icon alt text]": "Text Lettered Upper Case",
    "text numbered/[translation hint:default icon alt text]": "Text Numbered",
    "text paragraph/[translation hint:default icon alt text]": "Text Paragraph",
    "text roman lowercase/[translation hint:default icon alt text]": "Text Roman Lowercase",
    "text roman uppercase/[translation hint:default icon alt text]": "Text Roman Uppercase",
    "text size/[translation hint:default icon alt text]": "Text Size",
    "text size add/[translation hint:default icon alt text]": "Text Size Add",
    "text space after/[translation hint:default icon alt text]": "Text Space After",
    "text space before/[translation hint:default icon alt text]": "Text Space Before",
    "text strikethrough/[translation hint:default icon alt text]": "Text Strikethrough",
    "text stroke/[translation hint:default icon alt text]": "Text Stroke",
    "text style/[translation hint:default icon alt text]": "Text Style",
    "text subscript/[translation hint:default icon alt text]": "Text Subscript",
    "text superscript/[translation hint:default icon alt text]": "Text Superscript",
    "text tracking/[translation hint:default icon alt text]": "Text Tracking",
    "text underline/[translation hint:default icon alt text]": "Text Underline",
    "thumb down/[translation hint:default icon alt text]": "Thumb Down",
    "thumb up/[translation hint:default icon alt text]": "Thumb Up",
    "tips/[translation hint:default icon alt text]": "Tips",
    "transfer to platform/[translation hint:default icon alt text]": "Transfer To Platform",
    "transparency/[translation hint:default icon alt text]": "Transparency",
    "trap/[translation hint:default icon alt text]": "Trap",
    "tree collapse/[translation hint:default icon alt text]": "Tree Collapse",
    "tree collapse all/[translation hint:default icon alt text]": "Tree Collapse All",
    "tree expand/[translation hint:default icon alt text]": "Tree Expand",
    "tree expand all/[translation hint:default icon alt text]": "Tree Expand All",
    "trend inspect/[translation hint:default icon alt text]": "Trend Inspect",
    "trim path/[translation hint:default icon alt text]": "Trim Path",
    "trophy/[translation hint:default icon alt text]": "Trophy",
    "tumblr/[translation hint:default icon alt text]": "Tumblr",
    "twitter/[translation hint:default icon alt text]": "Twitter",
    "type/[translation hint:default icon alt text]": "Type",
    "usa/[translation hint:default icon alt text]": "USA",
    "underline/[translation hint:default icon alt text]": "Underline",
    "undo/[translation hint:default icon alt text]": "Undo",
    "ungroup/[translation hint:default icon alt text]": "Ungroup",
    "unlink/[translation hint:default icon alt text]": "Unlink",
    "unmerge/[translation hint:default icon alt text]": "Unmerge",
    "upload to cloud/[translation hint:default icon alt text]": "Upload To Cloud",
    "user/[translation hint:default icon alt text]": "User",
    "user activity/[translation hint:default icon alt text]": "User Activity",
    "user add/[translation hint:default icon alt text]": "User Add",
    "user admin/[translation hint:default icon alt text]": "User Admin",
    "user arrow/[translation hint:default icon alt text]": "User Arrow",
    "user checked out/[translation hint:default icon alt text]": "User Checked Out",
    "user edit/[translation hint:default icon alt text]": "User Edit",
    "user exclude/[translation hint:default icon alt text]": "User Exclude",
    "user group/[translation hint:default icon alt text]": "User Group",
    "user lock/[translation hint:default icon alt text]": "User Lock",
    "user share/[translation hint:default icon alt text]": "User Share",
    "users add/[translation hint:default icon alt text]": "Users Add",
    "users exclude/[translation hint:default icon alt text]": "Users Exclude",
    "users lock/[translation hint:default icon alt text]": "Users Lock",
    "users share/[translation hint:default icon alt text]": "Users Share",
    "vk/[translation hint:default icon alt text]": "VK",
    "variable/[translation hint:default icon alt text]": "Variable",
    "vector draw/[translation hint:default icon alt text]": "Vector Draw",
    "video checked out/[translation hint:default icon alt text]": "Video Checked Out",
    "video/[translation hint:default icon alt text]": "Video",
    "view all tags/[translation hint:default icon alt text]": "View All Tags",
    "view bi week/[translation hint:default icon alt text]": "View Bi-Week",
    "view card/[translation hint:default icon alt text]": "View Card",
    "view column/[translation hint:default icon alt text]": "View Column",
    "view day/[translation hint:default icon alt text]": "View Day",
    "view detail/[translation hint:default icon alt text]": "View Detail",
    "view grid/[translation hint:default icon alt text]": "View Grid",
    "view list/[translation hint:default icon alt text]": "View List",
    "view row/[translation hint:default icon alt text]": "View Row",
    "view single/[translation hint:default icon alt text]": "View Single",
    "view stack/[translation hint:default icon alt text]": "View Stack",
    "view week/[translation hint:default icon alt text]": "View Week",
    "viewed mark as/[translation hint:default icon alt text]": "Viewed Mark As",
    "vignette/[translation hint:default icon alt text]": "Vignette",
    "visibility/[translation hint:default icon alt text]": "Visibility",
    "visibility off/[translation hint:default icon alt text]": "Visibility Off",
    "visit/[translation hint:default icon alt text]": "Visit",
    "visit share/[translation hint:default icon alt text]": "Visit Share",
    "voice over/[translation hint:default icon alt text]": "Voice Over",
    "volume mute/[translation hint:default icon alt text]": "Volume Mute",
    "volume one/[translation hint:default icon alt text]": "Volume One",
    "volume three/[translation hint:default icon alt text]": "Volume Three",
    "volume two/[translation hint:default icon alt text]": "Volume Two",
    "watch/[translation hint:default icon alt text]": "Watch",
    "web page/[translation hint:default icon alt text]": "Web Page",
    "web pages/[translation hint:default icon alt text]": "Web Pages",
    "whats app/[translation hint:default icon alt text]": "Whats App",
    "windows 7/[translation hint:default icon alt text]": "Windows 7",
    "windows 8/[translation hint:default icon alt text]": "Windows 8",
    "wordpress/[translation hint:default icon alt text]": "Wordpress",
    "workflow/[translation hint:default icon alt text]": "Workflow",
    "workflow add/[translation hint:default icon alt text]": "Workflow Add",
    "wrench/[translation hint:default icon alt text]": "Wrench",
    "xd/[translation hint:default icon alt text]": "XD",
    "you tube/[translation hint:default icon alt text]": "YouTube",
    "zoom in/[translation hint:default icon alt text]": "Zoom In",
    "zoom out/[translation hint:default icon alt text]": "Zoom Out",
    "adobe experience platform/[translation hint:default icon alt text]": "Adobe Experience Platform",
    "calendar check/[translation hint:default icon alt text]": "Calendar Check",
    "emotion admiration/[translation hint:default icon alt text]": "Emotion: Admiration",
    "emotion anger/[translation hint:default icon alt text]": "Emotion: Anger",
    "emotion anticipation/[translation hint:default icon alt text]": "Emotion: Anticipation",
    "emotion disgust/[translation hint:default icon alt text]": "Emotion: Disgust",
    "emotion fear/[translation hint:default icon alt text]": "Emotion: Fear",
    "emotion joy/[translation hint:default icon alt text]": "Emotion: Joy",
    "emotion sadness/[translation hint:default icon alt text]": "Emotion: Sadness",
    "emotion surprise/[translation hint:default icon alt text]": "Emotion: Surprise",
    "facebook circle/[translation hint:default icon alt text]": "Facebook",
    "google plus circle/[translation hint:default icon alt text]": "Google Plus",
    "instagram circle/[translation hint:default icon alt text]": "Instagram",
    "linked in circle/[translation hint:default icon alt text]": "LinkedIn",
    "mc marketo engage/[translation hint:default icon alt text]": "Marketo Engage",
    "project camera/[translation hint:default icon alt text]": "Project Camera",
    "project play/[translation hint:default icon alt text]": "Project Play",
    "project refresh/[translation hint:default icon alt text]": "Project Refresh",
    "sina weibo circle/[translation hint:default icon alt text]": "Sina Weibo",
    "table cell merge/[translation hint:default icon alt text]": "Table Cell Merge",
    "target check/[translation hint:default icon alt text]": "Target Check",
    "twitter circle/[translation hint:default icon alt text]": "Twitter",
    "user circle/[translation hint:default icon alt text]": "User",
    "user group circle/[translation hint:default icon alt text]": "User Group",
    "windows/[translation hint:default icon alt text]": "Windows",
    "you tube circle/[translation hint:default icon alt text]": "YouTube"
  }
};
